import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { ProfilesModule } from '@app/features/profiles';

import { UserListComponent } from './user-list/user-list.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { RoleSelectComponent } from './role-select/role-select.component';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { CenterSelectComponent } from './center-select/center-select.component';
import { SisifoUserComponent } from './sisifo-user/sisifo-user.component';
@NgModule({
  declarations: [
    UserListComponent,
    UserDetailComponent,
    RoleSelectComponent,
    CenterSelectComponent,
    SisifoUserComponent,
  ],
  imports: [ProfilesModule, SharedModule, ToggleButtonModule],
})
export class UsersModule {}
